import { CommonModule } from '@angular/common';

import { ProjectsRoutingModule } from './projects-routing.module';
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component';
import { ProjectDetailComponent } from './project-detail/project-detail.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommentsDialogComponent } from 'src/app/components/comments-dialog/comments-dialog.component';
import { ProjectsListComponent } from './projects-list/projects-list.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { MultiFilterComponent } from 'src/app/components/multi-filter/multi-filter.component';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';


@NgModule({
    declarations: [
        ProjectDashboardComponent,
        ProjectDetailComponent,
        CommentsDialogComponent,
        ProjectsListComponent,
        MultiFilterComponent
    ],
    imports: [
        CommonModule,
        ProjectsRoutingModule,
        FormsModule,
        SharedModule
    ],
    exports: [ProjectDashboardComponent, ProjectDetailComponent,
        MultiFilterComponent,
        LoaderComponent, ProjectsListComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ProjectsModule { }
